import React from 'react'
import {cn} from '@/lib/utils'

interface ProductBadgesProps {
    badges?: string[]
    productId: string
    lmnBadgeColor?: string
    isLMNProduct?: boolean
}

export const ProductBadges: React.FC<ProductBadgesProps> = ({
    badges,
    productId,
    lmnBadgeColor,
    isLMNProduct
}) => {
    return (
        badges &&
        badges.length > 0 && (
            <div
                className={cn(
                    'absolute left-2 flex flex-col items-start gap-1 w-[60%] max-w-[60%] top-3'
                )}
            >
                {badges.map((badge, index) => (
                    <div
                        className={cn(
                            'text-primary-foreground px-[.3125rem] xs:px-[.225rem] lg:py-[.025rem] xs:py-[.125rem] text-[13px] font-grotesque font-medium cursor-pointer rounded-[3px]',
                            isLMNProduct && lmnBadgeColor ? null : 'bg-accent'
                        )}
                        style={
                            isLMNProduct && lmnBadgeColor
                                ? {backgroundColor: lmnBadgeColor}
                                : undefined
                        }
                        key={`${productId}-badge-${index}`}
                    >
                        {badge}
                    </div>
                ))}
            </div>
        )
    )
}
